module.exports = "data:image/png;base64,R0lGODlhAQABAIABADl1qf8AACH+EUNyZWF0ZWQgd2l0aCBHSU1QACwAAAAAAQABAAACAkQBADs="